<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="批次" name='batch_sn'>
      <a-input v-model:value="search.batch_sn" style="width:200px" placeholder="请输入批次号进行搜索"></a-input>
    </a-form-item>
    <a-form-item label="流水号" name='code_sn'>
      <a-input v-model:value="search.code_sn" style="width:200px" placeholder="请输入流水号进行搜索"></a-input>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)' v-if='!checkout' :ghost="!record.select">{{!record.select ?
        "选择":"已选择"}}</a-button>
      <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else>{{!record.select ? "选择":"已选择"}}
      </a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <div class="s_flex_center m-t-10" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
  <a-modal :keyboard="false" v-model:visible="visible" centered :width='1000' destroyOnClose :footer="null" title="提示">
    <a-form ref="form" :model='batchForm' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange'>
      <a-form-item label="批次" name='batch_sn'>
        <p>{{batchData.batch_sn}}</p>
      </a-form-item>
      <a-form-item label="二维码范围" name='is_all'>
        <a-radio-group v-model:value="batchForm.is_all">
          <a-radio :value="1">
            整批新增
          </a-radio>
          <a-radio :value="0">
            二维码区间
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="总流水号" v-if='batchForm.is_all==0'>
        {{batchData.small_serial_start}} - {{batchData.small_serial_end}}
      </a-form-item>
      <a-form-item label="流水号区间" name='start' v-if="!batchForm.is_all">
        <a-input placeholder="请输入流水号" style="width:200px" v-model:value="batchForm.small_serial_start" @blur="startHandle" /> -
        <a-input placeholder="请输入流水号" style="width:200px" v-model:value="batchForm.small_serial_end" :disabled="!batchForm.small_serial_start"/>
      </a-form-item>
      <a-form-item label="区间数量" v-if='batchForm.is_all==0&&batchForm.small_serial_end'>
        {{batchForm.small_serial_end-batchForm.small_serial_start+1}}
      </a-form-item>
      <a-form-item>
        <a-button class="m-r-10" @click="visible=false">取消</a-button>
        <a-button type="primary" @click="submitBatch">确定</a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { code_batchs } from "@/api/qrcode";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 5,
  batch_sn: "",
  code_sn: ""
};
export default {
  name: "selectCodeBatchQr",
  components: {},
  props: {
    selectList: {
      type: Array,
    },
    checkout: {
      type: Boolean,
    },
    direct:{ // 是否直接选择，不用选码段
      type:Boolean
    }
  },
  setup(props, { emit }) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    let batchForm = ref({
      small_serial_start: '',
      small_serial_end: '',
      is_all: 1,
    });
    const state = reactive({
      listLoading: false,
      total: 0,
      selectList: [],
      visible: false,
    });
    let columns = [
      {
        title: "批次",
        dataIndex: "batch_sn",
        key: "batch_sn",
      },
      {
        title: "码类型",
        dataIndex: "scenario_type_title",
        key: "scenario_type_title",
      },
      {
        title: "流水号区间",
        dataIndex: "small_serial",
        key: "small_serial",
        customRender: ({ text, record }) => {
          return record.small_serial_start + "-" + record.small_serial_end;
        },
      },
      {
        title: "数量",
        dataIndex: "small_code_counts",
        key: "small_code_counts",
      },

      {
        title: "添加时间",
        dataIndex: "created_time",
        key: "created_time",
      },

      {
        title: "操作",
        dataIndex: "action",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const batchData = ref({});
    //单选
    const select = (e) => {
      if(props.direct){
        data.value.map((item) => (item.select = false));
        if (e != 0) {
          e.select = !e.select;
        }
        emit("select", e);
      }else{
        batchData.value=e
        state.visible = true;
      }
    };
    const submitBatch = async () => {
       if(batchForm.value.is_all==0){
        batchData.value.small_serial_start=batchForm.value.small_serial_start;
        batchData.value.small_serial_end=batchForm.value.small_serial_end;
       }
       emit("select",batchData.value );
    };
        const startHandle = (e) => {
          console.log(e.target.value);
        if( e.target.value==''){
          batchForm.value.small_serial_end='';
        }
        }
    //多选
    const checkBnt = (e) => {
      if (!e.select) {
        state.selectList.push(e);
      } else {
        var index = 0;
        state.selectList.forEach((v, k) => {
          if (v.id == e.id) {
            index = k;
          }
        });
        state.selectList.splice(index, 1);
      }
      e.select = !e.select;
    };
    //多选确认
    const confirm = () => {
      emit("select", state.selectList);
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await code_batchs({ ...values }).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
          state.total = res.meta.total;
          if (state.selectList && state.selectList.length > 0) {
            data.value.forEach((i) => {
              if (
                state.selectList.find((v) => {
                  return i.id == v.id;
                })
              ) {
                i.select = true;
              }
            });
          }
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    onMounted(() => {
      if (props.selectList) {
        state.selectList = JSON.parse(JSON.stringify(props.selectList));
      }
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      select,
      checkBnt,
      confirm,
      batchData,
      batchForm,
      submitBatch,
      startHandle
    };
  },
};
</script>